<template>
    <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    inkscape:version="1.0 (4035a4fb49, 2020-05-01)"
    sodipodi:docname="polaris.svg"
    id="svg38"
    version="1.1"
    viewBox="0 0 15.420402 10.753472"
    height="139.47"
    width="199.99899">
        <metadata
            id="metadata44">
            <rdf:RDF>
            <cc:Work
                rdf:about="">
                <dc:format>image/svg+xml</dc:format>
                <dc:type
                rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                <dc:title></dc:title>
            </cc:Work>
            </rdf:RDF>
        </metadata>
        <defs
            id="defs42" />
        <sodipodi:namedview
            inkscape:current-layer="svg38"
            inkscape:window-maximized="1"
            inkscape:window-y="-6"
            inkscape:window-x="-6"
            inkscape:cy="62.087192"
            inkscape:cx="102.33972"
            inkscape:zoom="1.8834403"
            showgrid="false"
            id="namedview40"
            inkscape:window-height="890"
            inkscape:window-width="1368"
            inkscape:pageshadow="2"
            inkscape:pageopacity="0"
            guidetolerance="10"
            gridtolerance="10"
            objecttolerance="10"
            borderopacity="1"
            bordercolor="#666666"
            pagecolor="#ffffff" />
        <path
            sodipodi:nodetypes="cssssssssccscccccssssssccsssccccsssccscscssscccssssssscsssccccc"
            id="path60"
            d="m 2.2022112,10.610331 c -0.46128,-0.142002 -1.17759,-0.6552991 -1.49143005,-1.0687401 -0.12039,-0.158587 -0.31901,-0.499206 -0.44138,-0.756925 -0.2033,-0.428161 -0.2253,-0.580661 -0.25505,-1.767835 -0.0264,-1.052919 -0.011,-1.299388 0.0831,-1.299971 0.15051,-9.37e-4 4.34278005,0.601508 4.48124005,0.643969 0.0749,0.02296 -0.0189,0.387052 -0.32085,1.245334 -0.23466,0.667089 -0.41646,1.239166 -0.40399,1.271283 0.0125,0.03212 0.62631,-0.162499 1.3641,-0.432479 l 1.34143,-0.490872 0.16789,0.56438 c 0.0924,0.310409 0.27895,0.938176 0.41468,1.395053 l 0.24677,0.8306601 -2.39508,-0.0055 c -1.82328,-0.0044 -2.48969,-0.03503 -2.79139,-0.127935 z m 5.93638,-0.266169 c 0.0686,-0.22514 0.24427,-0.8310681 0.39043,-1.3465041 0.14615,-0.515442 0.27952,-0.960658 0.29639,-0.989371 0.0169,-0.02871 0.6355,0.169301 1.3747298,0.440027 0.73922,0.270729 1.35652,0.479824 1.37178,0.464656 0.0152,-0.01517 -0.16714,-0.575198 -0.40532,-1.244512 -0.23816,-0.669313 -0.404,-1.241634 -0.36851,-1.271824 0.0596,-0.05064 4.26241,-0.681957 4.5266,-0.679946 0.0958,7.67e-4 0.10961,0.229172 0.0764,1.257545 -0.0334,1.029567 -0.075,1.34571 -0.23075,1.749481 -0.24882,0.645135 -0.94273,1.3957721 -1.59605,1.7265161 0,0 -0.66798,0.272976 -1.07336,0.274991 -0.84401,0.0042 -1.95508,0.0023 -1.95508,0.0023 l -2.5319298,0.02597 z M 0.00103115,3.9743969 c 0.001,-1.605913 0.1844,-2.182411 0.94915,-2.99102101 0.26285005,-0.277926 0.61421005,-0.532423 0.94782005,-0.686517 0,0 0.41339,-0.249684 0.89858,-0.265628 0.7296,-0.02398 2.11464,-0.0041 2.11464,-0.0041 l 2.48309,-0.0249 -0.38348,1.30284801 c -0.21092,0.716565 -0.40818,1.346527 -0.43837,1.399913 -0.0377,0.06655 -0.47,-0.05697 -1.37544,-0.392959 -0.7263,-0.269515 -1.33117,-0.463433 -1.34416,-0.430928 -0.013,0.03251 0.16987,0.607949 0.40635,1.278764 0.23648,0.670817 0.41962,1.226357 0.40699,1.234533 -0.0126,0.0082 -1.06768,0.166983 -2.34458,0.352904 L 1.1151697e-5,5.0853419 Z m 12.82110985,0.74249 c -1.1246,-0.165206 -2.05829,-0.311934 -2.07487,-0.326063 -0.0166,-0.01413 0.16951,-0.586415 0.41353,-1.271749 0.24403,-0.685334 0.43011,-1.257606 0.41353,-1.271718 -0.0166,-0.01411 -0.62439,0.194407 -1.3507,0.463376 -0.7262998,0.268968 -1.3450598,0.465032 -1.3750298,0.435695 -0.0299,-0.02934 -0.159,-0.417554 -0.28676,-0.862707 -0.12776,-0.445154 -0.30241,-1.05110301 -0.38814,-1.34655601 L 8.0178612,-1.9105787e-5 10.505191,0.02598089 c 2.48412,0.02597 2.48796,0.0263 2.96615,0.250512 0.928,0.435128 1.58843,1.23691101 1.81673,2.20557701 0.0773,0.328133 0.13056,0.957583 0.13132,1.552868 l 0.001,1.001063 -0.27689,-0.0094 c -0.15229,-0.0052 -1.19701,-0.144539 -2.32161,-0.309746 z"
            style="stroke-width:0.0851968" />
    </svg>

</template>